import moment from 'moment';

export function getSeriesInXRangeDataFormat(
  seriesData: number[],
  pointStart: number,
  pointInterval: number
): { x: number; x2: number; y: number }[] {
  const maxDateEndPoint = moment();
  const xRangeData: { x: number; x2: number; y: number }[] = [];
  let previousYAxis: number = null;
  let regionStart = true;
  let regionStop = false;
  let startDateTimeRegionIndex: number = null;
  let endDateTimeRegionIndex: number = null;

  for (let i = 0; i < seriesData.length; i++) {
    const yAxis = seriesData[i];
    const isNewValueBreakPoint = previousYAxis !== yAxis;
    const isEndOfArray = i === seriesData.length - 1;

    if (isNewValueBreakPoint) {
      if (regionStop) {
        endDateTimeRegionIndex = i;
        regionStart = true;
        regionStop = false;

        xRangeData.push({
          x: moment(pointStart + startDateTimeRegionIndex * pointInterval).valueOf(),
          x2: moment(pointStart + endDateTimeRegionIndex * pointInterval).valueOf(),
          y: previousYAxis,
        });
      }
      previousYAxis = yAxis;

      if (regionStart) {
        if (yAxis === null) {
          continue;
        }
        startDateTimeRegionIndex = i;
        regionStart = false;
        regionStop = true;
      }
    }

    if (isEndOfArray) {
      if (yAxis === null) {
        continue;
      }
      endDateTimeRegionIndex = i + 1;
      regionStart = true;
      regionStop = false;

      xRangeData.push({
        x: moment(pointStart + startDateTimeRegionIndex * pointInterval).valueOf(),
        x2: moment
          .min(moment(pointStart + endDateTimeRegionIndex * pointInterval), maxDateEndPoint)
          .valueOf(),
        y: previousYAxis,
      });
    }
  }

  return xRangeData;
}
